import React from 'react';
import PropTypes from "prop-types";
import { inject, observer } from 'mobx-react';

import copy from "../copy";
import {getStates} from "../../../app/utils/get-states"
import {ListDropdown} from "../../components/dropdown";
import { SWITCHES } from '../../../app/enums/waffle';
import isPowersportsCollateral from '../../../app/utils/isPowersportsCollateral';

/**
 * Reusable component for rendering state form field
 *
 * @param {string}                 value - input value
 * @param {boolean|string}         error - whether or not the input should show the error view. When string, contains the error message
 * @param {function}               onChange - onChange event handler
 * @param {string}                 controlId - input control id
 */
export const StateField = inject('waffleStore', 'vehicleSelfSelectionStore', 'partnerStore')(observer(function StateField({onChange, required = true, waffleStore, vehicleSelfSelectionStore, partnerStore, ...props}) {
    const akHiEnabled = waffleStore.isSwitchActive(SWITCHES.ENABLE_AK_HI_STATES)
        && isPowersportsCollateral(vehicleSelfSelectionStore, partnerStore);
    const stateDropdownItems = getStates({ akHiEnabled });

    const handleChange = (event) => {
        onChange({value: event, error: required && !event});
    }
    return (
        <ListDropdown
            {...copy.state}
            items={stateDropdownItems}
            onChange={handleChange}
            {...props}
        />
    );
}));

StateField.propTypes = {
    value: PropTypes.string,
    error: PropTypes.oneOfType([PropTypes.bool, PropTypes.string, PropTypes.arrayOf(PropTypes.string)]),
    onChange: PropTypes.func,
    controlId: PropTypes.string,
};
